import ExpoAiLogo from 'pared/images/Expo/expoai.png'

import { IConfigsType } from '../../types'

const irmgBkHome: IConfigsType = {
  irmg_bk: {
    '/:brand/scorecard': {
      groupFilter: {
        api: 'locationFilter',
      },
      title: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      image: {
        type: 'image',
        src: ExpoAiLogo,
        alt: 'Expo AI',
        height: '40px',
      },
      exray: {
        type: 'ai-summary',
        fields: [
          'sales',
          'labor',
          'foodCost',
          'lossPrevention',
          'delivery',
          'guest',
        ],
      },
      // chatbox: {
      //   type: 'chatbox',
      // },
    },
  },
  // removed this block when the QA is finished
  'irmg_bk-only-for-qa': {
    '/:brand/scorecard': {
      groupFilter: {
        api: 'locationFilter',
      },
      title: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      image: {
        type: 'image',
        src: ExpoAiLogo,
        alt: 'Expo AI',
        height: '40px',
      },
      exray: {
        type: 'ai-summary',
        fields: [
          'sales',
          'labor',
          'foodCost',
          'lossPrevention',
          'delivery',
          'guest',
        ],
      },
      chatbox: {
        type: 'chatbox',
      },
    },
  },
}

export default irmgBkHome
